const DEFAULT_EXTENSIONS = [
  'jpeg',
  'jpg',
  'png',
]

export default {
  value: {
    type: [ Object, String ],
    default: () => null,
  },

  buttonText: {
    type: String,
    default: () => 'Adicionar',
  },

  placeholder: {
    type: String,
    default: () => 'Selecione um arquivo.'
  },

  /**
    * Allowed file extensions (preferably in lowercase)
    */
  extensions: {
    type: Array,
    default: () => DEFAULT_EXTENSIONS
  },

  /**
    * File size limit in the selected unit (megabyte by default)
    */
  sizeLimit: {
    type: [ Number, String ],
    default: 8,
    validator: v => Number(v) > 0 // valid number
  },

  width: {
    type: Number,
    default: () => 400
  },

  height: {
    type: Number,
    default: () => 248
  },

  errors: {
    type: Array,
    default: () => ([])
  },
}
